import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@material-ui/styles'
import MuiButton from '@material-ui/core/Button'
import { Icon } from 'components/icons'
import { LoadingIndicator } from 'components/loading'

const Button = props => {
  const theme = useTheme()
  const { icon, children, uppercase, isLoading, marginRight, marginLeft, padding, minWidth, width, ...otherProps } = props
  const loadingIndicator = isLoading ? <LoadingIndicator color={props.disabled ? theme.palette.common.black : theme.palette.primary.contrastText} /> : null
  let spacedIcon = null
  if (icon) {
    if (typeof icon === 'string') {
      spacedIcon = <React.Fragment><Icon name={icon} />{children && <React.Fragment>&nbsp;&nbsp;</React.Fragment>}</React.Fragment>
    } else {
      spacedIcon = <span style={{ marginRight: theme.spacing(1), ...icon.props.style }}>{icon}</span>
    }
  }
  const styling = {
    width: width,
    marginLeft: marginLeft,
    marginRight: marginRight,
    textTransform: uppercase ? 'uppercase' : 'inherit',
    padding: padding,
    minWidth: minWidth
  }
  return (
    <MuiButton style={styling} {...otherProps}>{loadingIndicator}{spacedIcon}{children}</MuiButton>
  )
}

export const propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  width: PropTypes.number,
  marginLeft: PropTypes.number,
  marginRight: PropTypes.number,
  uppercase: PropTypes.bool,
  size: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool
}
export const defaultProps = {
  width: 150,
  marginLeft: 0,
  marginRight: 0,
  uppercase: true,
  size: 'medium',
  variant: 'contained',
  color: 'primary',
  isLoading: false
}
Button.propTypes = propTypes
Button.defaultProps = defaultProps

export default Button
